export default __webpack_public_path__ + "static/media/2017.1fa9e9f2.png";